import { useState, useEffect, useRef } from "react";
import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AiFillCar } from "react-icons/ai";
import "./style.css";
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";
// ES6
import axios from "axios";
import Camra from "../camera_question";
import baseUrlNew from "../BaseUrl/index";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Damage from "../assets/images/carnew.jpg";
import Car1 from "../assets/images/cara.png";
import Car2 from "../assets/images/carb.png";
import Car3 from "../assets/images/carc.png";
import Car4 from "../assets/images/card.png";
import Car5 from "../assets/images/care.png";
import Slider from "@mui/material/Slider";
import DeskTopView from "../Desktopview";
import { IoArrowBackOutline } from "react-icons/io5";
import IMG2 from "../assets/images/carnew.jpg";
import RotateDeviceScreen from "../components/RotateDeviceScreen";
import FullscreenCapturePrompt from "../components/FullscreenCapturePrompt";
import {
  getViewportScreenMode,
  subscribeViewportOrientation,
  getStableViewportBox,
} from "../utils/viewportOrientation";
import {
  exitImmersiveMode,
} from "../utils/immersiveMode";
import {
  compressImageDataUrl,
  getGetUserMedia,
} from "../utils/cameraAccess";
import {
  persistDamagePhoto,
  loadDamagePhoto,
  clearDamagePhoto,
  memoryGetPhoto,
} from "../utils/damagePhotoStore";
import { useMobilePhotoDevice } from "../utils/isMobilePhotoDevice";

require('default-passive-events');

const DIAGRAM_WIDTH = 553;
const DIAGRAM_HEIGHT = 406;

function damageDraftKey(productId) {
  return `pi-damage-draft-${productId || "unknown"}`;
}

function readDamageDraft(productId) {
  if (!productId || typeof window === "undefined") {
    return null;
  }
  const key = damageDraftKey(productId);
  try {
    const raw =
      sessionStorage.getItem(key) || localStorage.getItem(key) || null;
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeDamageDraft(productId, draft) {
  if (!productId || typeof window === "undefined") {
    return;
  }
  const key = damageDraftKey(productId);
  // Never put the full image in web storage (quota). Metadata only.
  const payload = JSON.stringify({
    lable: draft?.lable || "",
    top: draft?.top || "48px",
    right: draft?.right || "95px",
    hasPhoto: Boolean(draft?.hasPhoto || draft?.imgs),
  });
  try {
    sessionStorage.setItem(key, payload);
  } catch {
    /* ignore */
  }
  try {
    localStorage.setItem(key, payload);
  } catch {
    /* ignore */
  }
}

function clearDamageDraft(productId) {
  if (!productId || typeof window === "undefined") {
    return;
  }
  const key = damageDraftKey(productId);
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
  clearDamagePhoto(productId);
}

function isDamageSurface(target) {
  if (!target || !target.id) {
    return Boolean(target?.closest?.("#overmain"));
  }
  return (
    ["imge_wrap", "viewport", "overmain", "ship", "image_map_tag", "point"].includes(
      target.id
    ) || Boolean(target.closest?.("#overmain"))
  );
}

function Appoinmentupdate({ id, image, close }) {
  let history = useHistory();
  const captureRootRef = useRef(null);
  const isMobileDevice = useMobilePhotoDevice();

  const location = useLocation();

  const notify = () => toast("Your damage point saved. You can add more or if not you can cancel and move to home");
  const notify2 = () => toast("Please Take photo of the damage and then submit.");
  const notify3 = () => toast("Please select the type of the damage.");
  const notifyPhoto = () => toast.success("Photo attached");
  const notifyNeedType = () =>
    toast("Photo attached. Select a damage type to enable Submit.");
  useEffect(() => {
    GetCarLenged();
    Get_Car_Dmage();
  }, []);

  // const [car_imge_, setcar_imge_] = useState(location.state.data)

  // // console.log("car image =======>>>>",car_imge_)

  // =========================api call section ==============

  // // console.log("base url export", baseUrlNew);
  const baseUrl = `${baseUrlNew.baseUrl}api/insert_inspection/`;
  const baseUrl2 = `${baseUrlNew.baseUrl}api/show_legend_car/`; 
  const baseUrl3 = `${baseUrlNew.baseUrl}api/v1/track_old/`; 
  const [points, setpoints] = useState([]);
  // console.log("base url after  export", baseUrl);

  const compressImageForUpload = (dataUrl) =>
    compressImageDataUrl(dataUrl, 1024, 0.62, 10000);

  const PostCarimge = async () => {
    const productId = location?.state?.id;
    if (!productId) {
      setLoading(false);
      toast.error("Missing vehicle id. Go back and open this screen again.");
      return;
    }

    setLoading(true);
    try {
      const compressed = await compressImageForUpload(imgs);
      const response = await axios.post(
        baseUrl,
        {
          left: right,
          top: top,
          product: productId,
          Car_legends: lable,
          imgs: compressed,
        },
        { timeout: 60000 }
      );

      const saved = response?.data?.data;
      if (saved) {
        setpoints((current) => [...current, saved]);
      }
      setimgs("");
      setlable("");
      clearDamageDraft(productId);
      notify();
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        err?.message ||
        "Could not save damage point.";
      toast.error(String(message));
    } finally {
      setLoading(false);
    }
  };




   const Get_Car_Dmage = () => {
    
     axios
       .post(baseUrl3, {
         product: location.state.id,
       })
       .then((response) => {
         // console.log("responseresponse=================>>>>>>>>>>>", response.data);
         setpoints(response.data.data);
         handler();
       });
   };


  const [lengeds, setlengeds] = useState([]);
  // console.log("api pointspoints=====", points);

  const GetCarLenged = () => {
    axios.get(baseUrl2).then((response) => {
      setlengeds(response.data.data);
      // console.log("api response", response.data);
    });
  };

  let [loading, setLoading] = useState(false);

  const carcamara_page = () => {
    if (!lable) {
      notify3();
    } else if (imgs && String(imgs).startsWith("data:")) {
      PostCarimge();
    } else {
      notify2();
    }
  };

  const [imge, setimg] = useState(Car3);

  const [sreen, setsreen] = useState(getViewportScreenMode);

  const handler = () => {
    var canvas = document.getElementById("viewport");
    if (!canvas) return;
    var context = canvas.getContext("2d");
    var base_image = new Image();
    base_image.src = IMG2;
    base_image.onload = function () {
      const cw = canvas.width;
      const ch = canvas.height;
      context.clearRect(0, 0, cw, ch);
      // Stretch to fill the section (no side letterboxing).
      context.drawImage(base_image, 0, 0, cw, ch);
    };
    canvas.addEventListener("touchstart", handleTouchEvent, false);
    canvas.addEventListener("touchmove", handleTouchEvent, false);
    canvas.addEventListener("touchcancel", handleTouchEvent, false);
    canvas.addEventListener("touchend", handleTouchEvent, false);
  };

  useEffect(() => {
    return subscribeViewportOrientation((mode) => {
      setsreen(mode);
      if (mode === "landscap") {
        handler();
      }
    });
  }, []);

  const productId = location?.state?.id;
  const draft = readDamageDraft(productId);

  const [imgs, setimgs] = useState(
    () => memoryGetPhoto(productId) || ""
  );
  const [showcamra, setshowcamra] = useState(false);

  useEffect(() => {
    if (!isMobileDevice) {
      setshowcamra(false);
      exitImmersiveMode();
      document.documentElement.classList.remove("pi-damage-lock");
      document.body.classList.remove("pi-damage-lock");
      return undefined;
    }

    if (sreen !== "landscap" || showcamra) {
      if (!showcamra) {
        exitImmersiveMode();
      }
      return undefined;
    }

    // Do not auto-enter immersive here — it pins bad viewport sizes after rotate
    // on Samsung Chrome. User can tap "Tap for full screen" instead.
    document.documentElement.classList.add("pi-damage-lock");
    document.body.classList.add("pi-damage-lock");

    return () => {
      document.documentElement.classList.remove("pi-damage-lock");
      document.body.classList.remove("pi-damage-lock");
      exitImmersiveMode();
    };
  }, [sreen, showcamra, isMobileDevice]);

  const [top, settop] = useState(() => draft?.top || "48px");
  const [right, setright] = useState(() => draft?.right || "95px");

  // will adjust ship's x to latest touch
  const handleTouchEvent = (e) => {
    // console.log("Touch event");
    if(e._reactName=="onTouchStart"){
      document.body.classList.add("stop-scrolling");
    }

    // console.log(e.target.id)
    if (e.touches.length === 0) {
      if(e._reactName=="onTouchEnd"){
        document.body.classList.remove("stop-scrolling");
      }
      
      return}
    var touch = e.touches[0];
    var targetT = document.elementFromPoint(touch.clientX, touch.clientY);
    // console.log("targetT ", targetT.id, targetT.className, targetT.classList);
    if (isDamageSurface(targetT)) {
      var ship = document.getElementById("ship");
      var zoomTarget = document.getElementById("pi-damage-zoom-target");
      if (!ship || !zoomTarget) return;

      const zoomRect = zoomTarget.getBoundingClientRect();
      if (!zoomRect.width || !zoomRect.height) return;

      // Map touch into logical diagram coords (section-fitted box).
      const localX =
        ((touch.clientX - zoomRect.left) / zoomRect.width) * DIAGRAM_WIDTH;
      const localY =
        ((touch.clientY - zoomRect.top) / zoomRect.height) * DIAGRAM_HEIGHT;
      const markerSize = 20;

      e.preventDefault();
      e.stopPropagation();

      const leftPx = Math.max(0, Math.min(DIAGRAM_WIDTH - markerSize, localX - markerSize / 2));
      const topPx = Math.max(0, Math.min(DIAGRAM_HEIGHT - markerSize, localY - markerSize / 2));
      const nextLeft = `${leftPx}px`;
      const nextTop = `${topPx}px`;

      // Position as % of the fitted section so the marker tracks the image.
      ship.style.left = `${(leftPx / DIAGRAM_WIDTH) * 100}%`;
      ship.style.top = `${(topPx / DIAGRAM_HEIGHT) * 100}%`;

      setright(nextLeft);
      settop(nextTop);
    }
    if(e._reactName=="onTouchEnd"){
      document.body.classList.remove("stop-scrolling");
    }
  };
  // });

  const [lable, setlable] = React.useState(() =>
    draft?.lable != null && draft?.lable !== "" ? String(draft.lable) : ""
  );

  // console.log("lable", lable);

  const handleChangeslect = (event) => {
    setlable(String(event.target.value));
  };

  const [itemshow, setitemshow] = useState(false);

  const refreshDamageLayout = () => {
    const root = captureRootRef.current;
    if (root) {
      // Clear stale inline sizes from earlier immersive/viewport bugs.
      root.style.width = "";
      root.style.height = "";
      root.style.minHeight = "";
      root.style.maxHeight = "";
      root.style.top = "";
      root.style.left = "";
      root.style.right = "";
      root.style.bottom = "";

      // Only re-apply size when the stable box looks like a full landscape screen.
      const { width, height } = getStableViewportBox();
      if (width > height && height >= 280) {
        root.style.height = `${height}px`;
        root.style.minHeight = `${height}px`;
        root.style.width = `${width}px`;
      }
    }
    handler();
  };

  // Keep draft metadata (photo lives in memory + IndexedDB).
  useEffect(() => {
    if (!productId) return;
    writeDamageDraft(productId, {
      hasPhoto: Boolean(imgs && imgs.startsWith("data:")),
      lable: lable || "",
      top,
      right,
    });
  }, [productId, imgs, lable, top, right]);

  // Restore photo + type after Android camera / remount.
  useEffect(() => {
    if (!productId) return undefined;
    let cancelled = false;

    const restore = async () => {
      const d = readDamageDraft(productId);
      if (d?.lable != null && d.lable !== "") {
        setlable((prev) => (prev ? prev : String(d.lable)));
      }
      if (d?.top) settop((prev) => prev || d.top);
      if (d?.right) setright((prev) => prev || d.right);

      const photo = await loadDamagePhoto(productId);
      if (cancelled || !photo) return;
      setimgs((prev) =>
        prev && prev.startsWith("data:") ? prev : photo
      );
    };

    restore();
    const onShow = () => {
      restore();
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") onShow();
    };
    window.addEventListener("pageshow", onShow);
    window.addEventListener("focus", onShow);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      cancelled = true;
      window.removeEventListener("pageshow", onShow);
      window.removeEventListener("focus", onShow);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [productId]);

  // Redraw diagram whenever the damage screen is visible again.
  useEffect(() => {
    if (showcamra || sreen !== "landscap") {
      return undefined;
    }

    let cancelled = false;
    const run = () => {
      if (!cancelled) {
        refreshDamageLayout();
      }
    };

    run();
    const raf1 = requestAnimationFrame(() => {
      run();
      requestAnimationFrame(run);
    });
    const t1 = setTimeout(run, 50);
    const t2 = setTimeout(run, 150);
    const t3 = setTimeout(run, 300);
    const t4 = setTimeout(run, 600);
    const t5 = setTimeout(run, 1000);

    const onViewport = () => run();
    window.addEventListener("resize", onViewport);
    window.addEventListener("orientationchange", onViewport);
    window.visualViewport?.addEventListener("resize", onViewport);
    window.visualViewport?.addEventListener("scroll", onViewport);

    return () => {
      cancelled = true;
      cancelAnimationFrame(raf1);
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
      clearTimeout(t5);
      window.removeEventListener("resize", onViewport);
      window.removeEventListener("orientationchange", onViewport);
      window.visualViewport?.removeEventListener("resize", onViewport);
      window.visualViewport?.removeEventListener("scroll", onViewport);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showcamra, sreen, imgs]);

  const hasPhoto = Boolean(imgs && String(imgs).startsWith("data:"));
  const canSubmit = hasPhoto && Boolean(lable) && !loading;

  const applyCapturedPhoto = async (dataUrl) => {
    if (!dataUrl) return false;
    let next = dataUrl;
    try {
      next = (await compressImageForUpload(dataUrl)) || dataUrl;
    } catch {
      next = dataUrl;
    }
    if (!next || !String(next).startsWith("data:")) {
      toast.error("Could not read that photo. Please try again.");
      return false;
    }

    setimgs(next);
    await persistDamagePhoto(productId, next);
    writeDamageDraft(productId, {
      hasPhoto: true,
      lable: lable || "",
      top,
      right,
    });
    setshowcamra(false);
    if (lable) {
      notifyPhoto();
    } else {
      notifyNeedType();
    }
    return true;
  };

  const save_pics = async (data) => {
    const url = data?.url;
    if (!url) {
      setshowcamra(false);
      return;
    }
    await applyCapturedPhoto(url);
  };

  const canLiveCamera = Boolean(getGetUserMedia()) && isMobileDevice;

  if (!isMobileDevice) {
    return <DeskTopView onBack={() => history.goBack()} />;
  }

  if (showcamra) {
    return (
      <>
        <Camra save_pics={save_pics} setshowcamra={setshowcamra} />
      </>
    );
  }




const legend = () => {
  var items = [];
  var html = "";
  return React.Children.toArray(lengeds.map((item) => {
    if (!items.includes(item.symbol)) {
      items.push(item.symbol);
      return (
        <p className="p_clor">
          <span className="pint_name">{item.symbol}:&nbsp;</span>
          {item.title}
       
        </p>
      );
    }
  }));


  
};








  return (
    <>
      {sreen == "landscap" ? (
          <div ref={captureRootRef} className="pi-damage-capture">
            <FullscreenCapturePrompt targetRef={captureRootRef} />
            <button
              type="button"
              className="pi-damage-capture__exit"
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await exitImmersiveMode();
                history.goBack();
              }}
              aria-label="Go back"
            >
              <IoArrowBackOutline size={20} />
            </button>

            <div className="pi-damage-capture__body">
              <section className="pi-damage-stage" id="overmain" aria-label="Vehicle diagram">
                <div className="pi-damage-fit-shell">
                  <div
                    id="pi-damage-zoom-target"
                    className="pi-damage-fit-target"
                  >
                    <div
                      className="buble pi-damage-marker"
                      id="ship"
                      style={{
                        top: `${((parseFloat(top) || 0) / DIAGRAM_HEIGHT) * 100}%`,
                        left: `${((parseFloat(right) || 0) / DIAGRAM_WIDTH) * 100}%`,
                        width: "20px",
                        height: "20px",
                        zIndex: "99999",
                      }}
                      onTouchMove={handleTouchEvent}
                      onTouchCancel={handleTouchEvent}
                      onTouchStart={handleTouchEvent}
                      onTouchEnd={handleTouchEvent}
                    />
                    <canvas
                      id="viewport"
                      className="pi-damage-fit-canvas"
                      height={DIAGRAM_HEIGHT}
                      width={DIAGRAM_WIDTH}
                      onTouchMove={handleTouchEvent}
                      onTouchCancel={handleTouchEvent}
                      onTouchStart={handleTouchEvent}
                      onTouchEnd={handleTouchEvent}
                    />
                    <div
                      className="taggd-wrapper pi-damage-fit-layer"
                      id="imge_wrap"
                      onTouchMove={handleTouchEvent}
                      onTouchCancel={handleTouchEvent}
                      onTouchStart={handleTouchEvent}
                      onTouchEnd={handleTouchEvent}
                    >
                      <img
                        alt="Car_certification_v2"
                        className="map maphilighted taggd"
                        id="image_map_tag"
                        src={IMG2}
                        style={{ display: "none" }}
                      />
                      {React.Children.toArray(
                        points.map((item) => {
                          const topPx = parseFloat(item.top) || 0;
                          const leftPx = parseFloat(item.left) || 0;
                          return (
                            <p
                              id="point"
                              className="car_up_text"
                              style={{
                                top: `${(topPx / DIAGRAM_HEIGHT) * 100}%`,
                                left: `${(leftPx / DIAGRAM_WIDTH) * 100}%`,
                              }}
                            >
                              {item.symbol}
                            </p>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
                <div className="pi-damage-stage__hint">
                  <span className="pi-damage-stage__hint-dot" aria-hidden />
                  Drag marker to damage point
                </div>
              </section>

              <aside className="pi-damage-side-panel" aria-label="Damage controls">
                <h2 className="pi-damage-side-panel__title">Add damage</h2>
                <div>
                  <p className="pi-damage-side-panel__label">Damage type</p>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="demo-simple-select-label">Type</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={lable}
                        label="Type"
                        onChange={handleChangeslect}
                        onClick={(e) => e.stopPropagation()}
                        onTouchStart={(e) => e.stopPropagation()}
                        MenuProps={{
                          // Keep menu inside the capture root so it stays
                          // visible when that element is in fullscreen.
                          container: () =>
                            captureRootRef.current || document.body,
                          disableScrollLock: true,
                          PaperProps: {
                            sx: {
                              maxHeight: 220,
                              zIndex: 10000,
                            },
                          },
                          sx: { zIndex: 10000 },
                        }}
                      >
                        {React.Children.toArray(
                          lengeds.map((item) => (
                            <MenuItem value={String(item.id)}>
                              {item.title}
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </div>

                <div>
                  <p className="pi-damage-side-panel__label">Legend</p>
                  <div className="title_list">{legend()}</div>
                </div>

                <div className="pi-damage-actions">
                  {hasPhoto ? (
                    <div className="pi-damage-photo-preview">
                      <img src={imgs} alt="Damage preview" />
                      <p className="pi-damage-photo-status" role="status">
                        {lable
                          ? "Photo ready — you can submit"
                          : "Photo saved — select damage type to submit"}
                      </p>
                    </div>
                  ) : (
                    <p className="pi-damage-photo-status is-empty" role="status">
                      Take a photo before submit
                    </p>
                  )}
                  {loading ? (
                    <span
                      className="btn text-center"
                      style={{ backgroundColor: "transparent" }}
                    >
                      <ClipLoader loading={loading} size={28} color="#fff" />
                    </span>
                  ) : (
                    <button
                      type="button"
                      disabled={!canSubmit}
                      onClick={carcamara_page}
                    >
                      Submit
                    </button>
                  )}
                  {canLiveCamera ? (
                    <button
                      type="button"
                      onClick={async (e) => {
                        e.stopPropagation();
                        writeDamageDraft(productId, {
                          hasPhoto,
                          lable: lable || "",
                          top,
                          right,
                        });
                        await exitImmersiveMode();
                        setshowcamra(true);
                      }}
                    >
                      {hasPhoto ? "Retake Photo" : "Take Photo"}
                    </button>
                  ) : null}
                  <button
                    type="button"
                    className="pi-damage-actions__ghost"
                    onClick={(e) => {
                      e.stopPropagation();
                      exitImmersiveMode();
                      history.push({
                        pathname: "/inspection/carsteps",
                        state: {
                          id: location.state.id,
                          car_name: location.state.car_name,
                          inspect: location.state?.inspect,
                          report: location.state?.report,
                        },
                      });
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </aside>
            </div>
            <ToastContainer />
          </div>
        ) : (
          <RotateDeviceScreen
            onBack={() => history.goBack()}
            description="Mark damage on your vehicle in landscape mode. Rotate your phone to continue."
          />
        )}
    </>
  );
}

export default Appoinmentupdate;
